import { LOCALE_CHANGE } from './localeActionTypes';
import { setGoogleTranslateLocale } from '../../utils/googleTranslate';

export const localeChange = (locale) => (dispatch) => {
    setGoogleTranslateLocale(locale);
    dispatch({ type: LOCALE_CHANGE, locale });
};

/** Syncs redux with a locale Google Translate already applied (e.g. from a previous session's cookie). */
export const localeSync = (locale) => ({
    type: LOCALE_CHANGE,
    locale,
});
